export const FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_BEGIN = 'FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_BEGIN'
export const FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_SUCCESS = 'FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_SUCCESS'
export const FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_FAILED = 'FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_FAILED'
export const REACHED_END_OF_CONVERSATION_MESSAGES = 'REACHED_END_OF_CONVERSATION_MESSAGES'

const fetchCurrentConversationMoreMessagesBegin   = (payload) => ({ type: FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_BEGIN, payload })
const fetchCurrentConversationMoreMessagesSuccess = (payload) => ({ type: FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_SUCCESS, payload })
const fetchCurrentConversationMoreMessagesFailed  = (payload) => ({ type: FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_FAILED, payload })
const reachedEndOfConversationMessages            = (payload) => ({ type: REACHED_END_OF_CONVERSATION_MESSAGES, payload })

export const fetchCurrentConversationMoreMessages = (conversation, {showLoading = true, scrollPosition = 0}) => {
  return (dispatch, getState) => {
    dispatch(fetchCurrentConversationMoreMessagesBegin({loadingMoreMessages: showLoading, scrollPosition: scrollPosition}))
    $.ajax({
      url:  `/api/staff/v1/conversations/${conversation.id}/messages.json?page=${conversation.page + 1}&q[s]=created_at+desc`,
      success: (response) => {
        if(response.length == 0){
          dispatch(reachedEndOfConversationMessages())
        } else {
          dispatch(fetchCurrentConversationMoreMessagesSuccess(response))
        }
      },
      error: () => dispatch(fetchCurrentConversationMoreMessagesFailed())
    })
  }
}